import { TFunction } from "i18next";
import * as Yup from "yup";

/**
 * Only a parse guard: by customer decision the ID-document details carry no rules (past validity dates
 * included), but a partially typed date cannot be sent at all.
 */
export function identityDocumentValidationSchema(t: TFunction) {
  return Yup.object({
    validUntil: Yup.date().nullable().typeError(t("common.validation.invalidDateFormat")),
  });
}
